// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var EnrollmentStatus;
(function (EnrollmentStatus) {
    EnrollmentStatus[EnrollmentStatus["Approved"] = 0] = "Approved";
    EnrollmentStatus[EnrollmentStatus["Rejected"] = 1] = "Rejected";
    EnrollmentStatus[EnrollmentStatus["Review_Required"] = 2] = "Review_Required";
    EnrollmentStatus[EnrollmentStatus["Review_Processing"] = 3] = "Review_Processing";
    EnrollmentStatus[EnrollmentStatus["Intake_Processing"] = 4] = "Intake_Processing";
    EnrollmentStatus[EnrollmentStatus["Disenrolled"] = 5] = "Disenrolled";
    EnrollmentStatus[EnrollmentStatus["Enrolled"] = 6] = "Enrolled";
    EnrollmentStatus[EnrollmentStatus["Canceled"] = 7] = "Canceled";
    EnrollmentStatus[EnrollmentStatus["Open"] = 8] = "Open";
    EnrollmentStatus[EnrollmentStatus["Unknown"] = -1] = "Unknown";
    EnrollmentStatus[EnrollmentStatus["EXP"] = 9] = "EXP";
})(EnrollmentStatus || (EnrollmentStatus = {}));
//# sourceMappingURL=enrollmentStatus.js.map